import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, boName, tableColumns}) => {
    const navigate = navigateHook();

    const columns = [
        {
            id: "id",
            label: boName,
            className: "w-[10%]",
            renderCell: element => <a onClick={() => navigate(`/bo/redirect/${element.id?.replace('/', '-')}`, true)} className="report-link">{element.id ?? ""}</a>
        },
        {id: "date", label: "Data/Hora", className: "w-[15%]", renderCell: element => element.date ?? ""},
        {id: "creator", label: "Cadastrado por", className: "w-[15%]", renderCell: element => element.creator ?? ""},
        {id: "evaluator", label: "Avaliado por", className: "w-[15%]", renderCell: element => element.evaluator ?? ""},
        {id: "action", label: "Ação", className: "w-[10%]", renderCell: element => {
            switch (element.action) {
                case 'approval.reject': return 'Reprovação';
                case 'approval.approve': return 'Aprovação';
                case 'invalidate': return 'Invalidação';
                default: return element.action ?? "";
            }
        }},
        {id: "justification", label: "Motivo", className: "w-[15%]", renderCell: element => element.justification ?? ""},
        {id: "observation", label: "Observação", className: "w-[20%]", renderCell: element => element.observation ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Aprovação e reprovação`, "approval-actions-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="approval-actions-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Aprovação e reprovação">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.map((element, index) => (
                        <tr key={index}>
                            {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;